import { GOVERNMENT_PORTAL_IMPERSONATE_URL_PARAM, UserType } from "@/constants";
import { SESSION_KEYS, sessionStorage } from "@/types/session-storage";

/** Deep-link into the government portal as the given government user. */
export function governmentImpersonatePortalHref(userId: string): string {
  return `/government/overview?${GOVERNMENT_PORTAL_IMPERSONATE_URL_PARAM}=${encodeURIComponent(userId.trim())}`;
}

export function isOperatorGovernmentImpersonating(): boolean {
  return Boolean(
    sessionStorage
      .get<string>(SESSION_KEYS.GOVERNMENT_PORTAL_IMPERSONATE_USER_ID, "")
      .trim(),
  );
}

export function getImpersonatedGovernmentJurisdictionId(): string | null {
  const raw = sessionStorage.get<string>(
    SESSION_KEYS.GOVERNMENT_PORTAL_IMPERSONATE_JURISDICTION_ID,
    "",
  );
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Real government users, or operators viewing the government portal as one. */
export function isGovernmentPortalViewer(
  userType: UserType | null | undefined,
): boolean {
  return (
    userType === UserType.GOVERNMENT ||
    (userType === UserType.OPERATOR && isOperatorGovernmentImpersonating())
  );
}
